import React, { Component } from "react";
import gif1 from "../../../../../globals/images/attend.gif";
import gif2 from "../../../../../globals/images/accept.gif";
import gif3 from "../../../../../globals/images/Timer.gif";
import styles from "./objectives.module.scss";
import analytics from './../../../../../utils/segmentUtils'

class Objectives extends Component {

    componentDidMount() {
        analytics.page('Objectives')
    }

    render() {
        let { introductionData } = this.props
        let objective1 = introductionData.step3.gif1 ? introductionData.step3.gif1 : gif1;
        let objective2 = introductionData.step3.gif2 ? introductionData.step3.gif2 : gif2;
        let objective3 = introductionData.step3.gif3 ? introductionData.step3.gif3 : gif3;

        return (
            <div className={styles["objectives-container"]}>
                <div className={styles["gif-container"]}>
                    <div>{introductionData.step3.title}</div>
                    <div className={styles.gifs}>
                        <div className={styles["gif-item"]}>
                            <div className={styles["gif"]}>
                                <img src={objective1} />
                            </div>
                            <div className={styles["gif-text"]}>{introductionData.step3.info1}</div>
                        </div>
                        <div className={styles["gif-item"]}>
                            <div className={styles["gif"]}>
                                <img src={objective2} />
                            </div>
                            <div className={styles["gif-text"]}>{introductionData.step3.info2}</div>
                        </div>
                        <div className={styles["gif-item"]}>
                            <div className={styles["gif"]}>
                                <img src={objective3} />
                            </div>
                            <div className={styles["gif-text"]}>{introductionData.step3.info3}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Objectives;



// WEBPACK FOOTER //
// /src/components/intro/pages/about/objectives/Objectives.js